module.exports = __webpack_public_path__ + "aab37f6220a98c1c42fdd14447247fad.png";